import { render, staticRenderFns } from "./HqSection.vue?vue&type=template&id=5341c826&"
import script from "./HqSection.vue?vue&type=script&lang=js&"
export * from "./HqSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports